import api from './api';

export interface PlansPayload {
  id: string;
  name: string;
  slug?: string;
  planType?: string;
  /** #128: exige Turnstile no checkout — vem do backend (plans.requires_turnstile). */
  requiresTurnstile?: boolean;
  /** PIX do valor TOTAL do ano no checkout público (plans.pix_a_vista) — só em anual à vista. */
  pixAVista?: boolean;
  /** Venda bloqueada (plans.sale_blocked): o plano existe, mas não aceita compra nova. */
  saleBlocked?: boolean;
  originalPrice: string;
  discountedPrice?: string;
  price: number;
  billingCycle: 'monthly' | 'annual';
  discountPercentage: number;
  active: boolean;
  includedItems: {
    name: string;
    active: boolean;
  }[];
  createdAt: Date;
  updatedAt: Date;
}

export const PlansService = {
  async getAll() {
    const response = await api.get('/plans?visible=true');
    return response.data.data;
  },

  async getPlanBySlug(slug: string) {
    const response = await api.get(`/plans/slug/${slug}`);
    const plan = response.data.data;

    // Mapear os dados do backend para o formato esperado pelo frontend
    // originalPrice e discountedPrice vêm como strings do backend devido ao tipo decimal
    const price = parseFloat(plan.discountedPrice || plan.originalPrice);

    return {
      ...plan,
      price: price,
      discountedPrice: `R$ ${price.toFixed(2).replace('.', ',')}`,
    };
  },
};
